import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ProductView } from 'src/app/models/products/products';
import { ProductDetailsUiStateService } from '../product-details-ui-state.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-details-cube',
  templateUrl: './details-cube.component.html',
  styleUrls: ['./../online-product-details.component.scss']
})
export class DetailsCubeComponent  {
  productView: ProductView = this.pUiService.productView;
  chosenOption = this.pUiService.chosenOption;

  constructor(
    public pUiService: ProductDetailsUiStateService,
    private _route: ActivatedRoute,
    ) { }


  GoToBasketFn(): void {
    this.pUiService.GoToBasket(this._route.snapshot.params.i);
  }
  
  backToStageOneFn(): void {
    this.pUiService.backToStageOne();
  }
}
